const DEFAULT_API_BASE_URL = "http://localhost:3008";
const GENERIC_API_ERROR_MESSAGE = "Algo salió mal. Intentalo nuevamente.";
const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

let csrfToken = null;

export function getApiBaseUrl() {
  return import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL;
}

export function setCsrfToken(nextToken) {
  csrfToken = nextToken || null;
}

export function clearCsrfToken() {
  csrfToken = null;
}

function buildRequestInit(options = {}) {
  const method = options.method || "GET";
  const headers = {
    ...(options.headers || {}),
  };

  if (!SAFE_METHODS.has(method.toUpperCase()) && csrfToken) {
    headers["X-CSRF-Token"] = csrfToken;
  }

  let body;

  if (options.body !== undefined) {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(options.body);
  }

  return {
    method,
    credentials: options.credentials || "include",
    headers,
    body,
  };
}

function createApiError(data, status = null) {
  const isServerError = typeof status === "number" && status >= 500;
  const message = isServerError
    ? GENERIC_API_ERROR_MESSAGE
    : data?.error?.message || GENERIC_API_ERROR_MESSAGE;
  const details = isServerError ? null : data?.error?.details ?? null;
  const code = isServerError ? "SERVER_ERROR" : data?.error?.code ?? "REQUEST_FAILED";
  const error = new Error(message);
  error.code = code;
  error.details = details;
  return error;
}

async function parseErrorResponse(response) {
  const text = await response.text();
  let data = null;

  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  throw createApiError(data, response.status);
}

export async function requestJson(path, options = {}) {
  let response;

  try {
    response = await fetch(`${getApiBaseUrl()}${path}`, buildRequestInit(options));
  } catch {
    const error = new Error(GENERIC_API_ERROR_MESSAGE);
    error.code = "NETWORK_ERROR";
    error.details = null;
    throw error;
  }

  const text = await response.text();
  let data = null;

  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  if (!response.ok) {
    throw createApiError(data, response.status);
  }

  return data;
}

export async function requestBlob(path, options = {}) {
  let response;

  try {
    response = await fetch(`${getApiBaseUrl()}${path}`, buildRequestInit(options));
  } catch {
    const error = new Error(GENERIC_API_ERROR_MESSAGE);
    error.code = "NETWORK_ERROR";
    error.details = null;
    throw error;
  }

  if (!response.ok) {
    await parseErrorResponse(response);
  }

  return response.blob();
}
